<template>
  <date-picker
    inline
    type="date"
    valueType="format"
    format="DD/MM/YYYY"
    :lang="lang"
    :value="value"
    :confirm="showConfirm"
    @confirm="onConfirm"
    @input="updateValue"
    @change="onChange"
    :disabled-date="disabledDateFn"
  >
  </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import 'vue2-datepicker/locale/th'

export default {
  components: {
    DatePicker,
  },

  props: {
    value: {
      type: [Date, String],
    },

    lang: {
      type: String,
      default: 'th',
    },

    showConfirm: {
      type: Boolean,
      default: false,
    },

    disabledDateFn: {
      type: Function,
    },
  },

  methods: {
    onConfirm() {
      this.$emit('onConfirm')
    },

    updateValue(value) {
      this.$emit('input', value)
    },

    onChange(value, type) {
      this.$emit('onChange', type)
    },
  },
}
</script>
